import { STORAGE_KEYS } from "./constants";

function safeParse(value, fallback) {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    return fallback;
  }
}

export function getStoredAuthSession() {
  return safeParse(localStorage.getItem(STORAGE_KEYS.auth), null);
}

export function setStoredAuthSession(session) {
  if (!session) {
    localStorage.removeItem(STORAGE_KEYS.auth);
    return;
  }

  localStorage.setItem(STORAGE_KEYS.auth, JSON.stringify(session));
}

export function clearStoredAuthSession() {
  localStorage.removeItem(STORAGE_KEYS.auth);
}
